import React, { useState } from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import './PermissionsStyle.scss';
import Icon from '@mdi/react';
import { mdiAppleKeyboardControl } from '@mdi/js';
import { capitalizeFirstChar } from '../utils';

function DescriptionPermissions() {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);

  const toogleBtn = () => setShow(!show);

  const showString = (title, type, descriptions) => (
    <div>
      <span className="font-weight-bold">
        {title}
        {type}
      </span>
      {descriptions}
    </div>
  );

  return (
    <Alert
      type="info"
      showIcon
      description={(
        <div className="d-flex justify-content-between">
          {!show ? (
            <div className="d-flex flex-column">
              {showString(
                capitalizeFirstChar(t('permissions.names.create', 'create')),
                ' (C) - ',
                capitalizeFirstChar(t('permissions.body.create_description', 'Allows the user to create entities')),
              )}

              {showString(
                capitalizeFirstChar(t('permissions.names.read', 'read')),
                ' (R) - ',
                capitalizeFirstChar(t('permissions.body.read_description', 'allows the user to get entities')),
              )}

              {showString(
                capitalizeFirstChar(t('permissions.names.update', 'update')),
                ' (U) - ',
                capitalizeFirstChar(t('permissions.body.update_description', 'Allows the user to update entities')),
              )}

              {showString(
                capitalizeFirstChar(t('permissions.names.delete', 'delete')),
                ' (D) - ',
                capitalizeFirstChar(t('permissions.body.delete_description', 'allows the user to remove entities')),
              )}

              {showString(
                capitalizeFirstChar(t('permissions.names.list', 'list')),
                ' (L) - ',
                capitalizeFirstChar(t('permissions.body.list_description', 'allows the user to access entities inside')),
              )}

              {showString(
                capitalizeFirstChar(t('permissions.names.set', 'set')),
                ' (S) - ',
                capitalizeFirstChar(t('permissions.body.super_set_description', 'allows the user to change owner or remove entities')),
              )}
              {showString(
                capitalizeFirstChar(t('permissions.names.affix_creator_delete')),
                ' (ACD) - ',
                capitalizeFirstChar(t('labels.assigned_acd_description')),
              )}
            </div>
          ) : (
            <div className="d-flex flex-column">
              Help me
            </div>
          )}
          <div className="ml-2">
            <div
              className="show-button"
              onClick={toogleBtn}
            >
              <span>
                {show ? 'Show' : 'Hide'}
              </span>
              <Icon
                path={mdiAppleKeyboardControl}
                size={0.8}
                className={`ml-1 pt-1 show-button__icon ${show ? 'show-button__icon-active' : ''}`}
              />
            </div>
          </div>
        </div>
      )}
    />
  );
}

export default DescriptionPermissions;
